export function emissionDateRangeFilters({ iniName, fimName, label = "Data Emissão" }) {
    const iniDefault = moment().subtract(60, "days").format("YYYY-MM-DD");
    const fimDefault = moment().add(1, "day").format("YYYY-MM-DD");

    return [
        {
            name: iniName,
            label: `${label} Início`,
            value: iniDefault,
            defaultValue: iniDefault,
            type: "input-date",
            applied: true,
            class: "form-control",
            columnSize: "col-3",
        },
        {
            name: fimName,
            label: `${label} Fim`,
            value: fimDefault,
            defaultValue: fimDefault,
            type: "input-date",
            applied: true,
            class: "form-control",
            columnSize: "col-3",
        },
    ];
}
